
import { baseQuery } from "../baseQuery";
import { createAccountGroupMaster, deleteAccountGroupMaster, listAccountGroupMasterCustom, updateAccountGroupMaster } from "../../graphql";
import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { dashboardApi } from "./dashboardApi";

const invalidateDashboardCache = async (_arg, { dispatch, queryFulfilled }) => {
  try {
    await queryFulfilled;
    dispatch(dashboardApi.util.invalidateTags(["dashboard"]));
  } catch {
    // no-op
  }
};

export const listGroupMasterApi = createApi({
  reducerPath: "listGroupMasterApi",
  tagTypes: ["listGroupMaster"],
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    listGroupMaster: builder.query({
      query: () => ({ body: listAccountGroupMasterCustom }),
      keepUnusedDataFor: 600,
      refetchOnMountOrArgChange: false,
      providesTags: ["listGroupMaster"],
    }),
    createAccountGroupMaster: builder.mutation({
      query: (variables) => ({ body: createAccountGroupMaster, variables }),
      invalidatesTags: ["listGroupMaster"],
      onQueryStarted: invalidateDashboardCache,
    }),
    updateAccountGroupMaster: builder.mutation({
      query: (variables) => ({ body: updateAccountGroupMaster, variables }),
      invalidatesTags: ["listGroupMaster"],
      onQueryStarted: invalidateDashboardCache,
    }),
    deleteAccountGroupMaster: builder.mutation({
      query: (variables) => ({ body: deleteAccountGroupMaster, variables }),
      invalidatesTags: ["listGroupMaster"],
      onQueryStarted: invalidateDashboardCache,
    }),
  }),
});

export const { useListGroupMasterQuery, useCreateAccountGroupMasterMutation, useUpdateAccountGroupMasterMutation, useDeleteAccountGroupMasterMutation } = listGroupMasterApi;

